// Vendored copy of @ag-grid-community/locale AG_GRID_LOCALE_ES — inlined to localize AG Grid's built-in strings without adding a runtime dependency.
const AG_GRID_LOCALE_ES: Record<string, string> = {
	selectAll: "(Seleccionar todo)",
	selectAllSearchResults: "(Seleccionar todos los resultados de la búsqueda)",
	addCurrentSelectionToFilter: "Agregar la selección actual al filtro",
	searchOoo: "Buscar...",
	blanks: "(Vacíos)",
	noMatches: "Sin coincidencias",

	filterOoo: "Filtrar...",
	equals: "Igual a",
	notEqual: "Distinto de",
	blank: "Vacío",
	notBlank: "No vacío",
	empty: "Elija uno",

	lessThan: "Menor que",
	greaterThan: "Mayor que",
	lessThanOrEqual: "Menor o igual que",
	greaterThanOrEqual: "Mayor o igual que",
	inRange: "Entre",
	inRangeStart: "Desde",
	inRangeEnd: "Hasta",

	contains: "Contiene",
	notContains: "No contiene",
	startsWith: "Comienza con",
	endsWith: "Termina con",

	dateFormatOoo: "aaaa-mm-dd",
	before: "Antes",
	after: "Después",

	andCondition: "Y",
	orCondition: "O",

	applyFilter: "Aplicar",
	resetFilter: "Restablecer",
	clearFilter: "Limpiar",
	cancelFilter: "Cancelar",

	textFilter: "Filtro de texto",
	numberFilter: "Filtro numérico",
	dateFilter: "Filtro de fecha",
	setFilter: "Filtro de conjunto",

	groupFilterSelect: "Seleccionar campo:",

	columns: "Columnas",
	filters: "Filtros",

	pivotMode: "Modo de tabla dinámica",
	groups: "Grupos de filas",
	rowGroupColumnsEmptyMessage: "Arrastre aquí para agrupar por filas",
	values: "Valores",
	valueColumnsEmptyMessage: "Arrastre aquí para agregar",
	pivots: "Etiquetas de columna",
	pivotColumnsEmptyMessage: "Arrastre aquí para establecer etiquetas de columna",

	group: "Grupo",

	rowDragRow: "fila",
	rowDragRows: "filas",

	loadingOoo: "Cargando...",
	loadingError: "ERR",
	noRowsToShow: "No hay filas para mostrar",
	noMatchingRows: "No hay filas coincidentes",
	enabled: "Habilitado",

	pinColumn: "Fijar columna",
	pinLeft: "Fijar a la izquierda",
	pinRight: "Fijar a la derecha",
	noPin: "Sin fijar",
	valueAggregation: "Agregación de valores",
	noAggregation: "Ninguna",
	autosizeThisColumn: "Autoajustar esta columna",
	autosizeAllColumns: "Autoajustar todas las columnas",
	groupBy: "Agrupar por",
	ungroupBy: "Desagrupar por",
	ungroupAll: "Desagrupar todo",
	addToValues: "Agregar ${variable} a valores",
	removeFromValues: "Quitar ${variable} de valores",
	addToLabels: "Agregar ${variable} a etiquetas",
	removeFromLabels: "Quitar ${variable} de etiquetas",
	resetColumns: "Restablecer columnas",
	expandAll: "Expandir todos los grupos de filas",
	collapseAll: "Contraer todos los grupos de filas",
	copy: "Copiar",
	ctrlC: "Ctrl+C",
	copyWithHeaders: "Copiar con encabezados",
	copyWithGroupHeaders: "Copiar con encabezados de grupo",
	cut: "Cortar",
	ctrlX: "Ctrl+X",
	paste: "Pegar",
	ctrlV: "Ctrl+V",
	export: "Exportar",
	csvExport: "Exportar a CSV",
	excelExport: "Exportar a Excel",
	columnFilter: "Filtro de columna",
	columnChooser: "Elegir columnas",
	chooseColumns: "Elegir columnas",
	sortAscending: "Orden ascendente",
	sortDescending: "Orden descendente",
	sortUnSort: "Quitar orden",

	sum: "Suma",
	first: "Primero",
	last: "Último",
	min: "Mín.",
	max: "Máx.",
	none: "Ninguno",
	count: "Recuento",
	avg: "Promedio",
	filteredRows: "Filtradas",
	selectedRows: "Seleccionadas",
	totalRows: "Total de filas",
	totalAndFilteredRows: "Filas",
	more: "Más",
	to: "a",
	of: "de",
	page: "Página",
	pageLastRowUnknown: "?",
	nextPage: "Página siguiente",
	lastPage: "Última página",
	firstPage: "Primera página",
	previousPage: "Página anterior",

	pageSizeSelectorLabel: "Tamaño de página:",
	footerTotal: "Total",

	pivotColumnGroupTotals: "Total",

	pivotChartAndPivotMode: "Gráfico dinámico y modo de tabla dinámica",
	pivotChart: "Gráfico dinámico",
	chartRange: "Rango del gráfico",

	thousandSeparator: ",",
	decimalSeparator: ".",

	true: "Verdadero",
	false: "Falso",
	invalidDate: "Fecha no válida",
	invalidNumber: "Número no válido",
	january: "Enero",
	february: "Febrero",
	march: "Marzo",
	april: "Abril",
	may: "Mayo",
	june: "Junio",
	july: "Julio",
	august: "Agosto",
	september: "Septiembre",
	october: "Octubre",
	november: "Noviembre",
	december: "Diciembre",

	ariaVisible: "visible",
	ariaHidden: "oculto",
	ariaChecked: "marcado",
	ariaUnchecked: "sin marcar",
	ariaIndeterminate: "indeterminado",
	ariaColumn: "Columna",
	ariaColumnGroup: "Grupo de columnas",
	ariaRowSelect: "Presione Espacio para seleccionar esta fila",
	ariaRowDeselect: "Presione Espacio para deseleccionar esta fila",
	ariaRowToggleSelection: "Presione Espacio para alternar la selección de la fila",
	ariaRowSelectAll: "Presione Espacio para alternar la selección de todas las filas",
	ariaSearch: "Buscar",
	ariaSearchFilterValues: "Buscar valores de filtro",
	ariaFilterColumn: "Columna de filtro",
	ariaColumnSelectAll: "Alternar selección de todas las columnas",
	ariaHeaderSelection: "Columna con selección de encabezado",
	ariaFilterList: "Lista de filtros",
	ariaFilterInput: "Entrada de filtro",
	ariaFilterValue: "Valor del filtro",
	ariaFilterMenuOpen: "Abrir menú de filtro",
	ariaFilteringOperator: "Operador de filtrado",
	ariaSortableColumn: "Presione Enter para ordenar",
	ariaMenuColumn: "Presione Alt+Abajo para abrir el menú de la columna",
	ariaLabelColumnMenu: "Menú de columna",
	ariaLabelCellEditor: "Editor de celda",
	ariaLabelDialog: "Diálogo",
	ariaLabelSelectField: "Campo de selección",
	ariaLabelTooltip: "Información sobre herramientas",
	ariaLabelContextMenu: "Menú contextual",
	ariaLabelColumnFilter: "Filtro de columna",
	ariaLabelCellSelection: "Selección de celda"
};

export default AG_GRID_LOCALE_ES;
